// import React from "react";
// import { ArrowRight, Star } from "lucide-react";
import Hero from "./Hero";
import About from "./About";
import Services from "./Services";
import Testimonials from "./Testimonials";
import Blog from "./Blog";
import ContactForm from "./ContactForm";
import Header from "./Header";
import ProgramModal from "./ProgramModal";
import SocialMediaIcons from "./SocialMediaIcons";
import PIPVideoPlayer from "./PIPVideoPlayer";
// import ClientsSection from "./ClientsSection";
import YouTubeGallery from "./YouTubeGallery";

function HomePage() {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Services />
      <Testimonials />
      <Blog />
      <YouTubeGallery />
      {/* <Videos /> */}
      {/* <Blog /> */}
      {/* <Location /> */}
      <ContactForm />
      <ProgramModal />

      <SocialMediaIcons />
      <PIPVideoPlayer />

      {/* <ClientsSection /> */}
    </>
  );
}

export default HomePage;
